// RootComponent/constants.js

// This will be used later in our root reducer and selectors

export const NAME = 'RootReducer';
